"use strict";

exports.__esModule = true;
exports.Surface = Surface;
var _react = _interopRequireDefault(require("react"));
var _excluded = ["component", "childComponent", "style", "width", "height", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Renders children at arbitrary positions on a surface.
 */
function Surface(_ref) {
  var _ref$component = _ref.component,
    Component = _ref$component === void 0 ? "div" : _ref$component,
    _ref$childComponent = _ref.childComponent,
    ChildComponent = _ref$childComponent === void 0 ? "div" : _ref$childComponent,
    style = _ref.style,
    width = _ref.width,
    height = _ref.height,
    children = _ref.children,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    style: Object.assign({}, style, {
      width: width,
      height: height,
      position: "relative"
    })
  }, extra), _react["default"].Children.map(children, function (child) {
    var _child$props = child.props,
      x = _child$props.x,
      y = _child$props.y,
      width = _child$props.width,
      height = _child$props.height;
    if (!x && !y && !width && !height) {
      return child;
    }
    var transform = "translate3d(" + x + "px, " + y + "px, 0)";
    var style = Object.assign({}, child.props.style, {
      transform: transform,
      width: width,
      height: height,
      position: "absolute"
    });
    return /*#__PURE__*/_react["default"].createElement(ChildComponent, {
      key: child.key,
      style: style
    }, child);
  }));
}